export const reportTypeLabels = {
  overall: 'Overall',
  custom: 'Custom Report',
};

export type ReportType = keyof typeof reportTypeLabels;
